/**
 * Helpers de filtrado por afiliación en los reportes.
 *
 * Dentro de un campamento todos los clubes comparten la misma asociación
 * (`affiliationName`: ADE / UG / ADONE), así que el único eje que discrimina
 * es la zona (`affiliationZone`). Por eso el filtro de afiliación es por zona.
 */

const defaultGetZone = (row) => row?.affiliationZone;

/** Ordena zonas de forma natural: "Zona 2" antes que "Zona 10". */
const compareZones = (a, b) =>
  String(a).localeCompare(String(b), 'es', { numeric: true, sensitivity: 'base' });

/** Zonas únicas presentes en las filas, ordenadas y sin vacíos. */
export const getAffiliationZones = (rows = [], getZone = defaultGetZone) =>
  [...new Set((rows || []).map(getZone).filter(Boolean))].sort(compareZones);

/** `true` si la fila pasa el filtro (zona vacía = "todas"). */
export const matchesAffiliationZone = (row, zone, getZone = defaultGetZone) =>
  !zone || getZone(row) === zone;

/** Filtra una lista por zona. */
export const filterByAffiliationZone = (rows = [], zone, getZone = defaultGetZone) =>
  !zone ? (rows || []) : (rows || []).filter((row) => getZone(row) === zone);
